import { useQuery } from '@apollo/client';
import { downloadReportPdf } from '@src/util/reportPdf/downloadReportPdf';
import './wardSecurity.css';
import swLogo from '@src/assets/img/ward.png';
import { getScheduleReportByJobIdQuery } from '@src/util/query/scheduleReport.query';
import { getReportTemplateById } from "@src/util/query/reportTemplate.query";
import { dutyReportToTemplateMapping } from '@src/util/mobileDutyReportToTemplateMapping/mobileDutyReportToTemplateMapping';
import { wrapReportDetailForLegacyLookup } from '@src/util/reportFieldAnswers/reportFieldAnswers';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faShareFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Button, message } from 'antd';
import Spinner from "@src/components/spinner";



export const WardSecurityMobileReport = (job=null)=>{



    const [processingPdf, setPdfProcessing] = useState(false);

    const param = useParams();

    const {data: reportData, loading: reportDataLoading, refetch: reportDataRefetch} = useQuery(getScheduleReportByJobIdQuery,{
        variables:{
            jobId: (param?.jobId || job?.jobId)
        },
        // skip: (!param?.jobId || !job?.jobId),
        fetchPolicy:'network-only'
    });

    // this layout reads reportDetail by hardcoded legacy label-slug (e.g. reportDetail?.sitename)
    // — fetch the template so wrapReportDetailForLegacyLookup can resolve those against new
    // submissions, which are keyed by instanceId instead
    const {data: templateData} = useQuery(getReportTemplateById,{
        variables:{
            templateId: dutyReportToTemplateMapping['wardSecurity']?.templateId
        },
        fetchPolicy:'network-only'
    });

   
    const [report, setReport] = useState(null);


    // drawn by wfc-server in this layout (utils/pdf/customReports/customReportPdf.ts)
    const downloadPdfFromUrl = async () => {
        setPdfProcessing(true);
        try {
            await downloadReportPdf({ jobId: param?.jobId || job?.jobId, templateId: dutyReportToTemplateMapping['wardSecurity']?.templateId, filename: 'Ward report' });
            message.success("Report downloaded successfully");
        } catch (err) {
            message.error(err?.message || "Couldn't create the PDF. Please try again.");
        } finally {
            setPdfProcessing(false);
        }
    };

    useEffect(()=>{
        if(reportData?.getScheduleReportByJobId?.response){

            const templateFields = templateData?.getReportTemplateById?.response?.template?.reportFields?.flatMap((s)=>s?.fields||[]) || [];
            const resp = reportData?.getScheduleReportByJobId?.response;
            setReport({...resp, reportDetail: wrapReportDetailForLegacyLookup(resp?.reportDetail, templateFields)});

        }else{
            setReport(null)
        }
    },[reportData?.getScheduleReportByJobId?.response, templateData]);


      

    return (
        reportDataLoading?
        <div className='row-flex' style={{justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <Spinner/>
        </div>
        :
        <div>
            
        
            <div id="pdfexportBtn" style={{display:'flex', justifyContent:'right', padding:'20px',
                // position: 'sticky',
                // top: '50px',
                // background: 'white',
            }}>
                
                    {/* <Button style={{fontSize:'14px'}} onClick={()=>{ navigator.clipboard.writeText(job?.copyLink); message.success("Link copied to share") }}>
                        Share Report &nbsp;<FontAwesomeIcon icon={faShareFromSquare} />
                    </Button> */}
                    <Button disabled={processingPdf} style={{fontSize:'14px'}} onClick={downloadPdfFromUrl}>
                        {processingPdf? 
                            <Spinner/>:
                            <>
                                Download Report &nbsp;<FontAwesomeIcon icon={faDownload} />
                            </>
                        }
                    </Button>
            </div>

            <div className='w-wrapper' id="pdfContent" style={{width: "297mm", pageBreakInside: "avoid", margin: '0 auto', maxHeight: "297mm"}}>
                
                <div className="w-report-header">
                    
                    <div className='w-report-title'>Planned Job Report</div>
                    
                    <div style={{width:'150px'}}>
                        <img src={swLogo} alt=""  style={{width:'100%'}}/>
                    </div>

                </div>


                <table style={{width:'70%'}}>
                    <tr>
                        <td colSpan={2} className='w-table-header'>Patrol Details</td>
                    </tr>
                    <tr>
                        <td>Title</td>
                        <td> {report?.reportDetail?.title || report?.reportDetail?.sitename} </td>
                    </tr>
                    <tr>
                        <td>Assigned Team</td>
                        <td> {report?.reportDetail?.assignedteam} </td>
                    </tr>
                    <tr>
                        <td>Assigned User</td>
                        <td> {report?.reportDetail?.assigneduser} </td>
                    </tr>
                    <tr>
                        <td>Location</td>
                        <td> {report?.reportDetail?.location} </td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td> {report?.reportDetail?.address || report?.reportDetail?.siteaddress} </td>
                    </tr>
                    <tr>
                        <td>Location No.</td>
                        <td> {report?.reportDetail?.locationno} </td>
                    </tr>
                    <tr>
                        <td>Service</td>
                        <td> {report?.reportDetail?.service} </td>
                    </tr>
                    <tr>
                        <td>Subject</td>
                        <td> {report?.reportDetail?.subject} </td>
                    </tr>
                    <tr>
                        <td>PO Number</td>
                        <td> {report?.reportDetail?.ponumber} </td>
                    </tr>
                </table>

                <table style={{width:'100%'}} className='mt32'>
                    <tr>
                        <th colSpan={3} className='w-table-header'>Patrol History</th>
                    </tr>
                    <tr>
                        <th >Date</th>
                        <th >Status</th>
                        <th >Notes</th>
                    </tr>

                    <tr>
                        <td>{report?.reportDetail?.date}</td>
                        <td> {report?.reportDetail?.status} </td>
                        <td> {report?.reportDetail?.notes} </td>
                    </tr>
                    <tr>
                        <td>On Site</td>
                        <td> {report?.reportDetail?.onsite} </td>
                    </tr>
                    <tr>
                        <td> Off Site </td>
                        <td> {report?.reportDetail?.offsite} </td>
                    </tr>
                    
                </table>


                <table style={{width:'100%'}} className='mt32'>

                    <tr>
                        <th colSpan={2} className='w-table-header'>Triggered Audit Results</th>
                    </tr>

                    <tr>
                        <th >Question</th>
                        <th >Answer</th>
                    </tr>

                    <tr>
                        <td>Confirm the site was secure on arrival ?</td>
                        <td>{report?.reportDetail['confirmthesitewassecureonarrival?']}</td>
                    </tr>

                    <tr>
                        <td>Are there any other people on site ?</td>
                        <td>{report?.reportDetail['arethereanyotherpeopleonsite?']}</td>
                    </tr>

                    <tr>
                        <td>Are there any vehicles on site ?</td>
                        <td>{report?.reportDetail['arethereanyvehiclesonsite?']}</td>
                    </tr>

                    <tr>
                        <td>Can you confirm the environment surrounding the site has not changed</td>
                        <td>{report?.reportDetail?.canyouconfirmtheenvironmentsurroundingthesitehasnotchanged}</td>
                    </tr>

                    <tr>
                        <td>Has the Site/building exterior remained the same ? (e.g. any construction activity ?)</td>
                        <td>{report?.reportDetail['hasthesite/buildingexteriorremainedthesame?(e.g.anyconstructionactivity?)']}</td>
                    </tr>

                    <tr>
                        <td>Is there evidence of fly tipping?</td>
                        <td>{report?.reportDetail['isthereevidenceofflytipping?']}</td>
                    </tr>

                    <tr>
                        <td>Is there any sign of property damage ?</td>
                        <td>{report?.reportDetail['isthereanysignofpropertydamage?']}</td>
                    </tr>

                    <tr>
                        <td>Are all walkways clear from obstruction.</td>
                        <td>{report?.reportDetail['areallwalkwaysclearfromobstruction.']}</td>
                    </tr>

                    <tr>
                        <td>Are all windows secure?</td>
                        <td>{report?.reportDetail['areallwindowssecure?']}</td>
                    </tr>

                    <tr>
                        <td>Are all fire exits secure?</td>
                        <td>{report?.reportDetail['areallfireexitssecure?']}</td>
                    </tr>

                    <tr>
                        <td>Does the report require escalation to the client?</td>
                        <td>{report?.reportDetail['doesthereportrequireescalationtotheclient?']}</td>
                    </tr>

                    <tr>
                        <td>Has any Non Ward/Vinci Signage been added to the Site Hoarding</td>
                        <td>{report?.reportDetail['hasanynonward/vincisignagebeenaddedtothesitehoarding?']}</td>
                    </tr>

                    

                </table>

                <table style={{width:'100%'}} className='mt32'>
                    
                    <tr>
                        <th colSpan={3} className='w-table-header'>Triggered Audit Failures</th>
                    </tr>

                    <tr>
                        <th >Question</th>
                        <th >failure</th>
                        <th >Location</th>
                    </tr>

                    <tr>
                        <td>Are there any vehicles on site ?</td>
                        <td>{report?.reportDetail['arethereanyvehiclesonsite?']}</td>
                    </tr>


                    

                </table>

                <table style={{width:'100%'}} className='mt32'>
                    
                    <tr>
                        <th colSpan={3} className='w-table-header'>Audit Completed By</th>
                    </tr>

                    <tr>
                        <th >Signature</th>
                        <th >Name</th>
                        <th >Response</th>
                    </tr>

                    <tr>
                        <td></td>
                        <td>{report?.reportDetail['name']}</td>
                        <td>{report?.reportDetail['response']}</td>
                    </tr>
    

                </table>
                
                <table style={{width:'100%'}} className='mt32'>
                            
                            <tr>
                                <th colSpan={3} className='w-table-header'>Photos</th>
                            </tr>
        
                            {!reportDataLoading ?
                                reportData?.getScheduleReportByJobId?.response?.filesURL && Object.values(reportData?.getScheduleReportByJobId?.response?.filesURL)?.map((file)=>(
        
                                    <tr >
                                        <td>
                                            <div style={{ width:'500px', height:'600px',  cursor:'pointer', margin: 'auto', padding:'10px', overflow:'hidden' }}
                                                onClick={()=>{
                                                    window.open(file, "_blank");
                                                }}
                                            >
                                                {/* Placeholder for image loading */}
                                                <img
                                                    src={file}
                                                    alt={"Image placeholder"}
                                                    placeholder={<Spinner />}
                                                    style={{ maxWidth: "100%", height: "auto" }} // Ensures responsiveness
                                                />
                                            </div>
                                        </td>
                                    </tr>
        
                                ))
                                :
                                null
                            }
        
        
                </table>

            </div>





            
        </div>
    );
}